module.exports = __webpack_public_path__ + "img/havvind.5c89313e.jpg";